import {SET_CNAE_LIST} from '../mutation-types';
import {getCnaes} from '@/api/cnae-api';

const initialState = {
    list: []
};

const getters = {
    activeCnaes: state => {
        return state.list.filter(cnae => cnae.active);
    }
};

const mutations = {
    [SET_CNAE_LIST](state, cnaes) {
        state.list = cnaes;
    }
};

const actions = {
    loadCnaes({commit}) {
        getCnaes().then(cnaes => {
            commit(SET_CNAE_LIST, cnaes)
        });
    }
};

export default {
    state: initialState,
    getters,
    mutations,
    actions
}